<ion-header class="ion-no-border" mode="ios">
  <ion-toolbar>
    <ion-button slot="start" fill="clear" color="dark" (click)="onClose()">Back</ion-button>
    <ion-title>Select template</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="modal-content">
    <template-selector [isMultiSelection]="false" [selectedTemplateId]="selectedTemplateId"
      (onTemplateSelected)="onTemplateSelected($event)">
    </template-selector>
  </div>
</ion-content>